import { Autocomplete, AutocompleteChangeDetails, AutocompleteChangeReason, Checkbox, TextField, TextFieldProps } from "@mui/material";
import React, { type JSX } from 'react';
import { SideSheetFieldPropsBase } from "../side-sheet/SideSheet";

export type SideSheetMultiSelectProps<T> = {
    value: T[];
    onChange: (
        event: React.SyntheticEvent,
        value: T[],
        reason: AutocompleteChangeReason,
        details?: AutocompleteChangeDetails<T> | undefined
      ) => void;
    options: T[],
    placeholder?: string | null;
    isOptionEqualToValue?: (option: T, value: T) => boolean;
    getOptionLabel: (option: T) => string;
    disablePortal?: boolean
    shrinkLabel?: boolean;
} & SideSheetFieldPropsBase;

export default function SideSheetMultiSelect<T>({
    id,
    //testId,
    label,
    ariaLabel,
    //readOnly,
    //helperText,
    sx,
    disabled,
    value,
    //children,
    onChange,
    options,
    placeholder,
    isOptionEqualToValue,
    getOptionLabel,
    disablePortal,
    shrinkLabel
}: SideSheetMultiSelectProps<T>): JSX.Element {

    return (
        <Autocomplete
            disabled={disabled}
            sx={{
                ...sx,
                //zIndex: 2001
            }}
            multiple
            id={id}
            aria-label={ariaLabel}
            options={options}
            disablePortal={disablePortal}
            disableCloseOnSelect
            disableClearable={true}
            //defaultValue={state.categories.length > 0 ? [defaultCategory] : undefined}
            isOptionEqualToValue={isOptionEqualToValue}
            getOptionLabel={getOptionLabel}
            value={value}
            renderOption={(props, option, { selected }) => {
                const {key, ...rest} = props;
                return (
                    <li key={key} {...rest}>
                        <Checkbox
                            style={{ paddingRight: 8 }}
                            checked={selected}
                        />
                        {getOptionLabel(option)}
                    </li>
                );
            }}
            renderInput={(params: TextFieldProps) => (
                <TextField
                    variant="filled"
                    {...params}
                    label={label}
                    placeholder={placeholder ?? undefined}
                    slotProps={{
                        ...params.slotProps,
                        inputLabel: {
                            ...params.slotProps?.inputLabel,
                            shrink: shrinkLabel
                        }
                    }}
                />
            )}
            onChange={onChange}
        />
    );
}